import { useEffect, useRef, useState } from "react";
import { AppGrid } from "../base/AppGrid_view";
import { ActionPerspectiveAssociatedImpactsGridModel } from "./ActionPerspectiveAssociatedImpactsGridView_model";
import { IF } from "../../../../../../components/hoc/If";
import { PositionedSpinner } from "../../../../../../components/ui/PositionedSpinner";
import { observer } from "mobx-react-lite";

interface ActionPerspectiveAssociatedImpactsGrid {
  data: any;
  organisationId: number;
  projectId: number;
}

export const ActionPerspectiveAssociatedImpactsGrid: React.FC<ActionPerspectiveAssociatedImpactsGrid> = observer(
  ({ data, organisationId, projectId }) => {
    const [gridModel, setGridModel] = useState(
      () => new ActionPerspectiveAssociatedImpactsGridModel(organisationId, projectId, data.id)
    );
    const gridRef = useRef<AppGrid>();

    useEffect(() => {
      if (gridModel.projectId !== +projectId || gridModel.organisationId !== organisationId) {
        setGridModel(new ActionPerspectiveAssociatedImpactsGridModel(organisationId, +projectId));
      }
      // eslint-disable-next-line
    }, [organisationId, projectId]);

    useEffect(() => {
      gridModel.onMount();

      return gridModel.onUnmount;
      // eslint-disable-next-line
    }, []);
    return (
      <>
        <h2>Associated Impacts</h2>
        <IF condition={gridModel.isLoading}>
          <PositionedSpinner />
        </IF>
        <IF condition={!gridModel.isLoading}>
          <AppGrid
            ref={gridRef}
            rowData={gridModel.impactData}
            columnDefs={gridModel.gridColumns}
            gridOptions={{ ...gridModel.gridOptions }}
            onGridReady={gridModel.onGridReady}
            shouldTrackSelectedCell={true}
            rowSelection="multiple"
          />
        </IF>
      </>
    );
  }
);
